<template>
  <v-list nav dense v-if="searchHistory.length" data-testid="explore-history">
    <v-list-item
      v-for="item in searchHistory"
      link
      class="px-4 history-item d-flex"
      :key="item.id"
      @click="$emit('select', item.term)"
    >
      <v-icon class="blue-grey--text text--darken-1 mr-4">
        mdi-clock-outline
      </v-icon>
      <div class="pa-0 body2 history-item-term">
        {{ item.term }}
      </div>
      <v-icon
        class="float-sm-right blue-grey--text text--darken-3 history-item-button"
        @click.stop="$emit('deleteItem', item.id)"
      >
        mdi-close
      </v-icon>
    </v-list-item>
    <div
      class="px-4 cursor-pointer history-item body2 blue--text"
      @click="$emit('deleteAll')"
    >
      {{ $t('common.clear_all') }}
    </div>
  </v-list>
  <div v-else class="pa-4 white">
    <span class="body2 blue-grey--text text--darken-3">{{
      $t('explore.search_history_empty')
    }}</span>
  </div>
</template>

<script>
export default {
  name: 'SearchHistory',

  props: {
    loading: Boolean,
    searchHistory: Array,
  },
}
</script>

<style>
.history-item {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 40px !important;
  height: 40px;
}
.history-item-term {
  flex: 1 1 auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.history-item-button {
  flex: 0 0 11px;
}
</style>
